export const permissionsPabx = [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_PABX_HABILITADO]
